import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      position="bottom-center"
      offset={80}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-white group-[.toaster]:text-slate-900 group-[.toaster]:border-slate-200 group-[.toaster]:shadow-lg group-[.toaster]:rounded-lg",
          description: "group-[.toast]:text-slate-600",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          success: "group-[.toaster]:bg-white group-[.toaster]:text-slate-900",
          error: "group-[.toaster]:bg-white group-[.toaster]:text-red-600",
        },
        duration: 1500,
      }}
      {...props} />
  );
}

// Custom toast functions with Sortly-style durations
const customToast = {
  success: (message, options = {}) => toast(message, { duration: 1500, ...options }),
  error: (message, options = {}) => toast.error(message, { duration: 3000, ...options }),
  info: (message, options = {}) => toast(message, { duration: 2000, ...options }),
  warning: (message, options = {}) => toast.warning(message, { duration: 2500, ...options }),
  loading: (message, options = {}) => toast.loading(message, options),
  dismiss: toast.dismiss,
  promise: toast.promise,
};

export { Toaster, customToast as toast }
